<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="POS" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="mr-2 mt-2 ">
            <div class="row">
            </div>
          </div>
          <CommonTable
              url="v1/get-pos-devices"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :mutedData="mutedData"
              customClass="table-hover-animation"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>


export default {
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'POS'},
      ],
      tableHeaderValues: [
        {
          title: 'Name',
          valueKey: 'name',
          html: true,
          alter: function (value) {
            return value
          }
        },
        {
          title: 'Channel',
          valueKey: 'channels',
          html: true,
          alter: function (value) {
            if(value && value.length > 0){
              return value[0].name + '/' + value[0].code
            }
            return ''
          }
        },
        {
          title: 'Device ID',
          valueKey: 'device_id',
          html: true,
          alter: function (value) {
            return value


          }
        },
        {
          title: 'Status',
          valueKey: 'status',
          html: true,
          alter: function (value) {
            var html = ''
            if (value == 0)
              html = `<div class="badge badge-pill  badge-glow badge-warning">Inactive</div>`
            else if(value == 1)
              html = `<div class="badge badge-pill  badge-glow badge-success">Active</div>`


            return html


          }
        },
      ],
      actions: [
        {
          title: 'Assign Staff',
          class: 'btn-primary ml-1 badge',
          cta: (row) => {
            this.$store.commit('setPosChannelData', row)
            this.$router.push({name:'pos-assign-staff', params: {id: this.encryptData(row.id)}})
          }
        },
      ],
      mutedData: [],
    }
  },
  methods: {

  }
}
</script>

